module.exports = __webpack_public_path__ + "img/helper2.29e23f7a.png";